const DEFAULT_CURRENCY = 'USD'
const DEFAULT_LANGUAGE = 'en'
const initialState = {
  currency: DEFAULT_CURRENCY,
  language: DEFAULT_LANGUAGE,
}

export default initialState
